(function($){
    $(document).ready(function(){
        $('div.ea-sort-fields>label:first-child').text("Sort By");
        var text = $('table.wp-list-table>thead>tr>th:first-child').text();
        text.replace("Id / Location	/ Service / Worker","Id / Type / Location / Service");
        $('table.wp-list-table>thead>tr>th:first-child').text(text);
        /*
        
        $.ajaxStop(function(){
            $('div.ea-sort-fields>label:first-child').text("Sort By");
            var text = $('table.wp-list-table>thead>tr>th:first-child').text();
            text.replace("Id / Location				/ Service / Worker","Id / Type / Location / Service");
            $('#bulk-connections-builder-content label').each(function(i){
                var text= $(this).text();
                if(text === "Locations :"){
                   text.replace("Locations :","Types :");
                }else if(text === "Services :"){
                    text.replace("Services :","Locations :");
                }else if(text === "Workers :"){
                    text.replace("Workers :","Services :");
                }
                $(this).text(text);
            });
            /*var html = $('tr.ea-editing.ea-row').html().replace("Location","Type").replace("Service","Location").replace("Worker","Service");
            $('tr.ea-editing.ea-row').html(html);*/
        //})
        
    });
})(jQuery)